'use client';

import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/_components/UIComponents/Skeleton';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/_components/UIComponents/Tooltip';
import { useConversationNavbar } from './useConversationNavbar.client';

export default function ConversationNavbarTitle() {
	const { conversationId, conversation, isPending, isPublic, isUpdatingVisibility } = useConversationNavbar();

	if (!conversationId) return null;

	if (isPending || !conversation) {
		return <Skeleton className='h-5 w-40' />;
	}

	return (
		<div className='flex min-w-0 items-center gap-2'>
			<h1
				className='truncate text-sm font-semibold sm:text-base'
				title={conversation.title}
			>
				{conversation.title || <span className='text-muted-foreground italic'>Untitled</span>}
			</h1>

			{(isPublic || isUpdatingVisibility) && (
				<Tooltip>
					<TooltipTrigger asChild>
						<span className='bg-accent/60 text-muted-foreground inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[10px] font-medium'>
							{isUpdatingVisibility ? <Loader2 className='h-3 w-3 animate-spin' /> : 'Public'}
						</span>
					</TooltipTrigger>
					<TooltipContent>This conversation is publicly accessible</TooltipContent>
				</Tooltip>
			)}
		</div>
	);
}
